import select from './select.vue';
import option from './option.vue';

export const MutipleSelect = select;
export const MutipleSelectOption = option;
